import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { XCircle, Save } from "react-feather";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { GET, PUT } from "../../../api/adminApi";

export default function ChangeLevel({
  modal: { show, data: { productId, name } = {} },
  setModal,
  getItems,
}) {
  const {
    handleSubmit,
    control,
    register,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      level: null,
      point: "",
    },
  });

  const [lvls, setLvls] = useState([]);

  const onHide = () => {
    setModal({ show: false, data: null });
  };

  const fetchLevels = async () => {
    try {
      const response = await GET("/services/admin/api/level-helper");
      if (response?.length > 0) {
        setLvls(
          response.map((lvl) => ({
            value: lvl.level,
            label: `Уровень ${lvl.level}`,
          })),
        );
      }
    } catch (error) {
      console.error("Error fetching levels:", error);
    }
  };

  const onSubmit = async (formData) => {
    const transformedData = {
      productId: productId,
      level: formData.level,
      point: formData.point,
    };

    try {
      const response = await PUT(
        "/services/admin/api/product-level-point-update",
        transformedData,
      );
      if (response?.success) {
        getItems();
        onHide();
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  useEffect(() => {
    fetchLevels();
  }, []);

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <h3> Изменение балла продукта:</h3>
          <p
            style={{
              fontSize: 15,
              color: "#4f66ff",
              padding: 0,
              margin: 0,
              marginTop: 5,
            }}
          >
            {name}
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          <div className="flex flex-col gap-4 w-full">
            {/* Level Selector */}
            <div className="flex flex-row items-center justify-between w-full">
              <label className="block text-sm font-medium mb-1">Уровень</label>
              <div style={{ width: 250 }}>
                <Controller
                  name="level"
                  control={control}
                  rules={{ required: "Уровень обязателен" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={lvls}
                      placeholder="Выберите уровень"
                      value={lvls.find(
                        (option) => option.value === field.value,
                      )}
                      onChange={(option) => field.onChange(option.value)}
                      isClearable
                    />
                  )}
                />
                {errors.level && (
                  <p className="text-danger text-sm mt-1">
                    {errors.level.message}
                  </p>
                )}
              </div>
            </div>

            {/* Point Input */}
            <div className="flex flex-row items-center justify-between w-full">
              <label className="block text-sm font-medium mb-1">Значение</label>
              <div className="flex flex-col">
                <input
                  type="number"
                  className={`border rounded p-2 w-full ${
                    errors.point ? "border-red-500" : "border-gray-300"
                  }`}
                  style={{ width: 250 }}
                  {...register("point", {
                    required: "Значение обязательно",
                    valueAsNumber: true,
                  })}
                />
                {errors.point && (
                  <p className="text-danger text-sm mt-1">
                    {errors.point.message}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div
            className="flex justify-end gap-4 w-full mt-8"
            style={{ justifyContent: "flex-end" }}
          >
            <button
              type="button"
              onClick={onHide}
              className="btn btn-light-dark flex items-center"
            >
              <XCircle size={14} className="mr-2" />
              Отмена
            </button>
            <button
              type="submit"
              className="btn btn-light-primary flex items-center"
            >
              <Save size={14} className="mr-2" />
              Сохранить
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
